import { IApiResponse } from "clients/AbstractApiClient/IApiResponse";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TGetChargeRequestSchema,
  TGetChargeResponseSchema,
} from "./getCharge.schema";

export const getCharge = (axios: IAxiosInstance) => {
  return async (data: TGetChargeRequestSchema) => {
    const { companyID, ...params } = data;

    const response = await axios.noRetry.get<
      IApiResponse<TGetChargeResponseSchema>
    >(`/charges-and-fees/${companyID}/charges`, {
      params,
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
